import React from 'react';
import LightGallery from 'lightgallery/react';
import 'lightgallery/scss/lightgallery.scss';
import { Cell } from 'react-table';

const imageFormatter = (cell: Cell): JSX.Element => {
  return (
    <div className="image-container">
      <LightGallery
        licenseKey={process.env.REACT_APP_LIGHTGALLERY_API_KEY}
        startAnimationDuration={0}
        speed={0}
        toggleThumb={false}
        backdropDuration={200}
        slideEndAnimation
        controls={false}
        counter={false}
        download={false}
      >
        <img className="formatted-image" src={cell.value} alt="Orb asset" />
      </LightGallery>
    </div>
  );
};

export default imageFormatter;
